import { IPageData } from '@umu/umu-types';
import { PAY_METHOD } from '../../@marketCommon/interface/base';
import { ILabel } from '../../@marketCommon/interface/label';

export type IIntelligentCourseListPageData = IPageData;

export interface ISearchParam {
    job_label_id?: number;
    job_level_label_id?: number;
    applicable_scenario_label_id?: number;
}

export interface IPageConfig {
    conditions: intelligentConfigType;
    enterprise_info: {
        account_quota: number;
        used_account_quota: number;
    };
}

export type intelligentConfigType = Record<string, ILabel[]>;

export interface ISearchResult {
    condition: ILabel[];
    list: IIntelligentCourse[];
    hasMore: boolean;
}

export interface IIntelligentCourse {
    id: string;
    category_id: string;
    obj_title: string;
    owner_name: string;
    owner_desc: string;
    session_num: number;
    duration: number;
    cover_url: string;
    label_list: ILabel[];
    purchase_method_list: Record<PAY_METHOD, MethodPayType>;
    product_label_name: string;
    // 2022-06-09 15:11:15 https://wiki.umu.work/pages/viewpage.action?pageId=33971859
    is_permanent_enterprise_license?: 1 | 0; //（是否企业买断),
    purchased_num?: number; // (课程被购买的次数, 仅针对企业管理员
    can_buy_online?: 0 | 1; //(能否在线购买）
    discount: number; // 0.88 展示需要 * 10
    deleted?: 1 | 0; // 是否已经删除
}

export interface IShowList {
    id: string;
    title: string;
    method: string;
    price: number;
    account: number;
    amount: number;
}

export interface IDownloadData {
    demand_explain: number[];
    data: Array<{
        conditions: ILabel[];
        account_num: number;
        course_list: {
            id: string;
            purchase_method: PAY_METHOD;
        }[];
    }>;
}

export interface IDownloadDataPost {
    demand_explain: string;
    data: string;
}

export type ISearchMore = {
    page: number;
    size: number;
    filter_ids: string;
} & ISearchParam;

export type MethodPayType = {
    method: PAY_METHOD;
    amount: number;
};

export enum CONDITION_TYPE {
    POSITION = 1,
    STAGE,
    SCENE,
}

export type ISelectCourseItem = Record<string, PAY_METHOD>;
export type ISelectCourse = ISelectCourseItem[];

export type IResponse<T> = Promise<{
    data: T;
}>;
